import Forecast from './Forecast';
import Summary from './Summary';

function App() {
  return (
    <div className="App" >
      <Summary />
      <Forecast />
    </div>
  );
}

export default App;